import { render, staticRenderFns } from "./ChanliangAll.vue?vue&type=template&id=81702db6"
import script from "./ChanliangAll.vue?vue&type=script&lang=js"
export * from "./ChanliangAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports